import * as userTypes from '../types/userTypes'

const initialState = {
  singleUser: [],
  userSpendings: [],
  userPurchase: {},
}

const userReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case userTypes.GET_SINGLE_USER:
      return {
        ...state,
        singleUser: payload,
      }
    case userTypes.GET_USER_PURCHASE:
      return {
        ...state,
        userPurchase: payload,
      }
    case userTypes.GET_USER_SPENDINGS:
      return {
        ...state,
        userSpendings: payload,
      }
    default:
      return state
  }
}

export default userReducer
